// === Module Import ===
import bootbox from "bootbox";
import * as utils from "../components/utils";

// === Script Name ===
const SCRIPT_NAME = "intro_bootbox.js";

/**************************************************
 * Bootbox Helper - Zentrale Initialisierung von Bootbox Confirm
 **************************************************/

// Sprachtexte (Fallback-Standardwerte aus PHP, falls keine Übersetzungen geladen sind)
const DEFAULT_TEXTS = {
    confirmTitle: "Confirmation",
    confirmDescription: "Are you sure you want to do this?",
    confirmYes: "Yes",
    confirmNo: "No",
    confirmClass: "btn-danger",
    cancelClass: "btn-outline-secondary",
};

/**
 * Bootbox Confirm Helper
 * @param {Object} customOptions Benutzerdefinierte Einstellungen (optional)
 * - Überschreibt Standardkonfiguration
 */
export const bootboxConfirm = (customOptions = {}) => {
    utils.consoleLog(SCRIPT_NAME, "Starte Bootbox Confirm mit Optionen:", customOptions);

    const DEFAULTS = {
        title: DEFAULT_TEXTS.confirmTitle,
        message: `<p class="my-2">${DEFAULT_TEXTS.confirmDescription}</p>`,
        centerVertical: true,
        swapButtonOrder: true,
        buttons: {
            confirm: {
                label: DEFAULT_TEXTS.confirmYes,
                className: DEFAULT_TEXTS.confirmClass,
            },
            cancel: {
                label: DEFAULT_TEXTS.confirmNo,
                className: DEFAULT_TEXTS.cancelClass,
            },
        },
        callback: () => {
            utils.consoleLog(SCRIPT_NAME, "Bootbox Confirm Callback ausgeführt mit Result: Kein Ergebnis übergeben");
        }, // Leere Standardfunktion
    };

    // Benutzerdefinierte Optionen mit den Standardoptionen mergen
    const OPTIONS = { ...DEFAULTS, ...customOptions };

    utils.consoleLog(SCRIPT_NAME, "Zusammengeführte Optionen für Bootbox Confirm:", OPTIONS);

    // Bootbox Confirm aufrufen
    bootbox.confirm(OPTIONS);
};

/**************************************************
 * Event-Listener für alle Buttons mit `[data-confirm]`
 **************************************************/

/**
 * Initialisiere Event-Listener für Bootbox-Buttons
 */
export const initBootboxButtons = () => {
    utils.consoleLog(SCRIPT_NAME, "Initialisiere Bootbox Buttons");

    $('[data-confirm]').on('click', function (e) {
        e.preventDefault();

        const $ITEM = $(this);

        utils.consoleLog(SCRIPT_NAME, "Button mit [data-confirm] geklickt", {
            element: $ITEM,
            data: {
                confirmTitle: $ITEM.data('confirm-title'),
                confirmText: $ITEM.data('confirm-text'),
                confirmYes: $ITEM.data('confirm-yes'),
                confirmNo: $ITEM.data('confirm-no'),
                confirmClass: $ITEM.data('confirm-class'),
            },
        });

        // Daten aus den `data-`-Attributen entnehmen oder Standardwerte verwenden
        const OPTIONS = {
            title: $ITEM.data('confirm-title') || DEFAULT_TEXTS.confirmTitle,
            message: `<p class="my-2">${$ITEM.data('confirm-text') || DEFAULT_TEXTS.confirmDescription}</p>`,
            buttons: {
                confirm: {
                    label: $ITEM.data('confirm-yes') || DEFAULT_TEXTS.confirmYes,
                    className: $ITEM.data('confirm-class') || DEFAULT_TEXTS.confirmClass,
                },
                cancel: {
                    label: $ITEM.data('confirm-no') || DEFAULT_TEXTS.confirmNo,
                    className: DEFAULT_TEXTS.cancelClass,
                },
            },
            callback: (result) => {
                if (result) {
                    utils.consoleLog(SCRIPT_NAME, "Benutzer hat bestätigt (Result: true). Ursprünglicher Event wird erneut ausgelöst.");

                    // Wenn der Benutzer bestätigt hat, ursprüngliches Event erneut auslösen
                    $ITEM.off('click'); // Event-Handler entfernen
                    e.currentTarget.click(); // Ursprünglichen Klick auslösen
                } else {
                    utils.consoleLog(SCRIPT_NAME, "Benutzer hat abgelehnt (Result: false).");
                }
            },
        };

        // Registriere und führe den Bootbox Confirm Dialog aus
        bootboxConfirm(OPTIONS);
    });

    $('[data-duplicate-object]').on('click', function (e) {
        e.preventDefault();

        const $ITEM = $(this);
        const $FORM = $('#formDuplicateObject');

        bootbox.dialog({
            title: $ITEM.data('duplicate-title') || DEFAULT_TEXTS.confirmTitle,
            message: `<p class="my-2">${$ITEM.data('duplicate-text') || DEFAULT_TEXTS.confirmDescription}</p>`,
            centerVertical: true,
            swapButtonOrder: true,
            buttons: {
                confirm: {
                    label: $ITEM.data('duplicate-yes'),
                    className: 'btn-success',
                    callback: function() {
                        $('#includeUsers').val('Y');
                        $FORM.submit();
                    }
                },
                no: {
                    label: $ITEM.data('duplicate-no'),
                    className: 'btn-danger',
                    callback: function() {
                        $('#includeUsers').val('N');
                        $FORM.submit();
                    }
                },
                cancel: {
                    label: $ITEM.data('duplicate-cancel'),
                    className: DEFAULT_TEXTS.cancelClass
                }
            }
        });
    });

    utils.consoleLog(SCRIPT_NAME, "Bootbox Buttons erfolgreich initialisiert.");
};
